<template lang="pug">
.add-groups
  v-card
    v-card-title
      h2.card-title {{ 'base.animal_groups' | translate }}
    v-card-content
      v-multiselect(
        :class="{'mb-3': selectedItems.length}"
        :label="$t('base.animal_groups')"
        :options="groupsList"
        :comparator="(a, b) => a.id === b.id"
        v-model="selectedItems")
      template(
        v-if="selectedItems.length")
        h3.add-groups__label {{ 'base.list' | translate }}
        transition-group.add-groups__list(
          name="fade"
          tag="ul")
          li.add-groups__item(
            v-for="item in selectedItems"
            :key="item.id")
            span.add-groups__text {{ item.name }}
            span.add-groups__icon(
              @click="removeItem(item.id)")
              v-icon.add-groups__icon(
                font-size="1"
                icon="times")

    v-card-actions
      v-btn(
        :loading="loading"
        @click="onSave") {{ 'base.save' | translate }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AddGroupsModal',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    selectedItems: [],
    loading: false
  }),

  created () {
    this.initializeSelectedItems()
  },

  computed: {
    ...mapGetters('groups', [
      'groupsList'
    ]),

    filteredGroups () {
      return this.selectedItems
        .map(item => ({
          group: item.id,
          name: item.name,
          plan_weight: item.plan_weight || 0,
          animal_count: item.animal_count || 0,
          coefficient: item.coefficient || 100,
          ordering: 1
        }))
    }
  },

  watch: {
    items: {
      handler () {
        this.initializeSelectedItems()
      },
      deep: true
    }
  },

  methods: {
    removeItem (id) {
      this.selectedItems = this.selectedItems
        .filter(item => item.id !== id)
    },

    initializeSelectedItems () {
      this.selectedItems = this.items
        .map(item => ({
          id: item.group,
          name: item.name,
          coefficient: item.coefficient,
          plan_weight: item.plan_weight,
          animal_count: item.animal_count
        }))
    },

    onSave () {
      this.$emit('on-update', this.filteredGroups)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.add-groups {

  &__item {
    display: flex;
    justify-content: space-between;
  }

  &__item:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  &__label {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    color: $color-gray;
  }

  &__text {
    font-size: 1.6rem;
  }

  &__icon {
    cursor: pointer;
  }
}
</style>